import {
  queryAllDisplays,
  queryOpencodes,
  queryAllLotterys
} from "@/api/trend";

import {
  ADD_TREND_DISPS_LIST,
  ADD_TREND_RECORDS_LIST,
  ADD_TREND_LOTTERY_TYPES,
  SET_TREND_CURRENT_LOTTERY
} from "@/store/mutation_types";
const tend = {
  state: {
    dispsList: [],
    recordsList: [],
    lotteryTypes: [],
    //  defaultLottery: 0,
    currentLottery: {
      lotteryId: "",
      lotteryName: "",
      code: "",
      lotteryIcon: "",
      optionBalls: "",
      openBallCount: "",
      disps: null
    }
  },
  getters: {
    trendDispsList: state => state.dispsList,
    trendRecordsList: state => state.recordsList,
    trendLotteryTypes: state => state.lotteryTypes,
    //  trendDefaultLottery: state => state.defaultLottery,
    trendCurrentLottery: state => state.currentLottery
  },
  mutations: {
    [ADD_TREND_DISPS_LIST]: (state, playload) => {
      state.dispsList = playload;
    },
    [ADD_TREND_RECORDS_LIST]: (state, playload) => {
      state.recordsList = playload;
    },
    [ADD_TREND_LOTTERY_TYPES]: (state, playload) => {
      state.lotteryTypes = playload;
    },
    /*    [ADD_TREND_DEFAULT_LOTTERY]: (state, playload) => {
      state.defaultLottery = playload;
    }, */
    [SET_TREND_CURRENT_LOTTERY]: (state, playload) => {
      const {
        lotteryId,
        lotteryName,
        code,
        lotteryIcon,
        optionBalls,
        openBallCount,
        disps
      } = playload;

      state.currentLottery = {
        lotteryId,
        lotteryName,
        code,
        lotteryIcon,
        optionBalls,
        openBallCount,
        disps
      };
    }
  },
  actions: {
    async queryAllLotterys({ commit }, playload) {
      const rRes = await queryAllLotterys(playload);
      const {
        data: { data = {} }
      } = rRes;
      commit(ADD_TREND_LOTTERY_TYPES, data.types);
      //   commit(ADD_TREND_DEFAULT_LOTTERY, data.defaultLottery);
      return data;
    },
    async getDefaultCurrentLottery({ commit, state, dispatch }, lotteryId) {
      const allLottery = state.lotteryTypes;
      // const lotteryId = state.defaultLottery;
      let currentLottery = null;

      if (lotteryId) {
        for (let item of allLottery) {
          currentLottery = item.lotterys.find(
            item01 => item01.lotteryId == lotteryId
          );
          if (currentLottery) {
            break;
          }
        }
      }
      if (!currentLottery && allLottery.length) {
        currentLottery = allLottery[0].lotterys[0];
      }
      commit(SET_TREND_CURRENT_LOTTERY, currentLottery || {});
    },
    async queryAllDisplays({ commit }, playload) {
      const rRes = await queryAllDisplays(playload);
      const {
        data: { data = {} }
      } = rRes;
      commit(ADD_TREND_DISPS_LIST, data.disps);
      return rRes;
    },
    async queryOpencodes({ commit }, playload) {
      const rRes = await queryOpencodes(playload);
      const {
        data: { data = {} }
      } = rRes;
      commit(ADD_TREND_RECORDS_LIST, data.records);
      return rRes;
    }
  }
};
export default tend;
